import * as React from 'react';
import { AnimatedBackground } from './animated-background';

export interface AppPageHeaderProps {
  icon: React.ReactNode;
  badge: string;
  title?: string;
  subtitle: string;
  children?: React.ReactNode;
}

const AppPageHeader: React.FC<AppPageHeaderProps> = ({
  icon,
  badge,
  title,
  subtitle,
  children,
}) => {
  return (
    <section className="relative pt-20 pb-10 sm:pt-24 sm:pb-12 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900" />
      <AnimatedBackground variant="hero" intensity="subtle" />
      <div className="relative container mx-auto px-4 sm:px-6 max-w-6xl text-center">
        {title ? (
          <>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 text-blue-300 rounded-full text-sm font-medium mb-4 border border-white/10 backdrop-blur-sm">
              {icon}
              {badge}
            </span>
            <h1 className="text-2xl sm:text-3xl font-bold text-white mb-3">
              {title}
            </h1>
          </>
        ) : (
          <h1 className="inline-flex items-center gap-2 text-2xl sm:text-3xl font-bold text-white mb-3">
            {icon}
            {badge}
          </h1>
        )}
        <p className="text-slate-300 text-sm sm:text-base max-w-xl mx-auto">
          {subtitle}
        </p>
        {children && (
          <div className="mt-6">
            {children}
          </div>
        )}
      </div>
    </section>
  );
};

export { AppPageHeader };
